import { axios } from '@Root/API'

export const edit = payload => {
	return axios.post('table-manager/additional-fields', payload)
}
